import container from '../services/Container';

export default class CurrencyService {

	/**
	 * @return {Currency}
	 */
	static getCurrency() {
		return container.state.ui.currency;
	}

	/**
	 * @return {Currency}
	 */
	static getDefaultCurrency() {
		return container.state.ui.defaultCurrency;
	}

	/**
	 * @return {string}
	 */
	static getCurrencyCode() {
		return CurrencyService.getCurrency().code;
	}

	/**
	 * @return {string}
	 */
	static getSymbolBefore() {
		return CurrencyService.getCurrency().symbolBefore;
	}

	/**
	 * @return {string}
	 */
	static getSymbolAfter() {
		return CurrencyService.getCurrency().symbolAfter;
	}

	/**
	 * @param {object} currencies
	 * @param {string} defaultMutationId
	 * @return {?Currency}
	 */
	static findDefaultCurrency(currencies, defaultMutationId) {
		return currencies.find((currency) => (defaultMutationId === currency.defaultMutationId));
	}

	/**
	 * @param {string} code
	 * @param {object} [state]
	 *
	 * @return {?Currency}
	 */
	static findCurrencyByCode(code, state) {
		if (!code) {
			return null;
		}
		code = code.toUpperCase();
		return CurrencyService.getCurrencies(state).find((currency) => (code === currency.code));
	}

	/**
	 * @param {object} [state]
	 *
	 * @return {Currency[]}
	 */
	static getCurrencies(state) {
		state = state || container.state;
		return state.currencies.items;
	}

	/**
	 * @param {number} number
	 *
	 * @return {string}
	 */
	static format(number) {
		const currency = CurrencyService.getCurrency();
		const rounded = CurrencyService.round(number);
		return `${currency.symbolBefore} ${rounded} ${currency.symbolAfter}`.trim();
	}

	/**
	 * @param {number} number
	 *
	 * @return {string}
	 */
	static round(number) {
		const precision = CurrencyService.getCurrency().roundingPrecision;
		return number.toFixed(precision)
			.replace(new RegExp('\\.0{' + precision + '}$'), '');
	}
}


// WEBPACK FOOTER //
// ./services/CurrencyService.js